// Simplify: no undefined state -> instant readiness if user already cached.
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "./firebase";

let authUser: User | null = auth.currentUser ?? null;
let listeners = new Set<(u: User | null) => void>();

onAuthStateChanged(auth, u => {
  authUser = u ?? null;
  listeners.forEach(l => l(authUser));
});

export function getAuthUser() {
  return authUser;
}

export function subscribeAuth(cb: (u: User | null) => void) {
  listeners.add(cb);
  cb(authUser);
  return () => listeners.delete(cb);
}

// Instant promise (already resolved); kept for API compatibility.
export function waitForAuth(): Promise<User | null> {
  return Promise.resolve(authUser);
}

// Run only if user exists (by default); no delay if not signed in.
export async function runAfterAuth<T>(
  _label: string,
  fn: (u: User) => Promise<T>,
  opts: { requireUser?: boolean } = { requireUser: true }
) {
  const u = authUser;
  if (!u) {
    if (opts.requireUser) return;
    return fn(undefined as unknown as User);
  }
  return fn(u);
}
